/**
 * Sales > Pipeline — placeholder view.
 *
 * Pre-PR #40 this route mounted `<PipelineBoard />`, the current-step
 * opportunity kanban described in spec section 5.7. UAT Round 4 paused
 * that surface while Peter re-maps the layout, so the route now renders
 * a brief under-construction card. The `PipelineBoard` component is
 * left in place under `frontend/src/components/sales/PipelineBoard.tsx`
 * so the next round can re-mount it without rebuilding the board.
 *
 * Reference: spec section 15.8, design README section 5.7, UAT
 * walkthrough fixes round 4 (PR #40).
 */

import { createFileRoute } from '@tanstack/react-router';

/**
 * Render the placeholder for the Pipeline tab. The copy is factual:
 * Pipeline is offline by design, Opportunities holds the working
 * step-kanban in the meantime. Exported so the component test can
 * mount it without booting the full router shell.
 */
export function PipelinePlaceholder() {
  return (
    <div className="border border-mx-grey-800 bg-mx-card">
      <div className="flex flex-col items-center justify-center py-mx-8 text-center">
        <p className="mono-label text-mx-grey-mid">UNDER CONSTRUCTION</p>
        <h2 className="mt-mx-3 font-display text-mx-h2 font-semibold text-mx-white">
          Pipeline view is being rethought
        </h2>
        <p className="mt-mx-2 max-w-[400px] text-mx-body-sm text-mx-grey-300">
          Use the Opportunities tab for the current-step kanban. The Pipeline tab lands again in a
          future round with the layout Peter is mapping out.
        </p>
      </div>
    </div>
  );
}

export const Route = createFileRoute('/sales/pipeline')({
  component: PipelinePlaceholder,
});
